import image_fm_store from "../../assets/images/fm-store-3.png";
import image_welcome_fm from "../../assets/images/welcome-to-the-family.png";

function SectionWelcome() {
    return (
        <div className="section-welcome px-[20px] md:px-[50px] lg:px-[70px] xl:px-[100px] bg-[#F1F8FF]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div>
                    <img src={image_fm_store} className="w-100" alt="FamilyMart Indonesia" />
                </div>
                <div className="text-gray-500">
                    <img src={image_welcome_fm} className="w-100 mb-5" alt="FamilyMart Indonesia" />
                    <p className="mb-4">FamilyMart is one of the biggest convenience stores. Started the first store in 1973 in Japan, FamilyMart now has more than 23.000 stores in many countries. In Indonesia, FamilyMart started the business under PT Fajar Mitra Indah in 2012.</p>
                    <p className="mb-0">We aim to make our customers lives more comfortable and enjoyable, primarily by displaying hospitality in everything we do, and by ensuring a shopping experience characterized by CONVENIENCE, FRIENDLINESS and FUN. Still, we are developing our business and accelerating expansion in upcoming years.</p>
                </div>
            </div>
        </div>
    );
}

export default SectionWelcome;
